import { Component } from '@angular/core';

import {
  IonicModule,
  LoadingController,
  ModalController,
} from '@ionic/angular';

import { HttpClient } from '@angular/common/http';
import { UtilService } from 'src/app/services/util/util-service';
import { FormsModule } from '@angular/forms';

import { TranslateModule } from '@ngx-translate/core';
	import { TranslateService } from '@ngx-translate/core';
	import * as en from './i18n/en.json';
	import * as es from './i18n/es.json';
	import * as pt from './i18n/pt.json';
	import { firstValueFrom } from 'rxjs';
import { HeaderComponent } from '../../../components/header/header.component';

@Component({
    selector: 'app-fuel-places-modal',
    templateUrl: './fuel-places-modal.component.html',
    styleUrls: ['./fuel-places-modal.component.scss'],
    imports: [IonicModule, HeaderComponent, FormsModule, TranslateModule]
})
export default class FuelPlacesModalComponent {
  customerColor = localStorage.getItem('cor');
  clientId = localStorage.getItem('id_cliente');
  database = localStorage.getItem('apelido');
  addressesList = [];
  filteredAddressesList = [];
  searchTerm = '';
  isAddressesLoaded = false;

  constructor(
    private translate: TranslateService,
    private loadingController: LoadingController,
    private http: HttpClient,
    private util: UtilService,
    private modalCtrl: ModalController
  ) {
    this.loadLocalTranslations();
  }

  async ionViewWillEnter() {
    await this.getRegisteredAddresses();
  }

  loadLocalTranslations() {
  this.translate.setTranslation('en', en, true);
  this.translate.setTranslation('pt', pt, true);
  this.translate.setTranslation('es', es, true);
}


  async getRegisteredAddresses() {
    const msg = await firstValueFrom(
      this.translate.get('FETCHING-REGISTERED-ADDRESSES'),
    );

    const loading = await this.loadingController.create({
      message: msg,
    });

    await loading.present();

    const params = {
      id_cliente: this.clientId,
      database: this.database,
    };

    const url = 'https://web.hapolo.com.br/locais/local-list';

    try {
      this.http.get(url, { params }).subscribe(async (res: any) => {
        if (!res.success) {
          const msg = await firstValueFrom(
            this.translate.get('REGISTERED-ADDRESS-ERROR'),
          );

          await this.util.showToastError(msg);
          await loading.dismiss();
          return;
        }

        this.addressesList = res.address_list;
        this.filteredAddressesList = this.addressesList;
      });
    } catch (e) {
      const msg = await firstValueFrom(
        this.translate.get('REGISTERED-ADDRESS-ERROR'),
      );

      await this.util.showToastError(msg);
      await loading.dismiss();

      console.error(e);
    } finally {
      await loading.dismiss();
      this.isAddressesLoaded = true;
    }
  }

  searchAdddress(event: Event) {
    const eventValue = (event.target as HTMLInputElement).value;
    const term = eventValue.toLowerCase();

    this.filteredAddressesList = this.addressesList.filter((address) => {
      const local: string = address.local.toLowerCase();
      return local.includes(term);
    });
  }

  async selectAddress(address: string) {
    await this.modalCtrl.dismiss(address, 'confirm');
  }
}
